import {AuthRepository} from '../repositories/AuthRepository';
import {
  TwoFactorSendCodeRequest,
  TwoFactorSendCodeResponse,
} from '../entities/User';

export class Send2FACodeUseCase {
  constructor(private readonly authRepository: AuthRepository) {}

  async execute(
    request: TwoFactorSendCodeRequest,
    token?: string,
  ): Promise<TwoFactorSendCodeResponse> {
    if (!request.type || (request.type !== 'sms' && request.type !== 'email')) {
      throw new Error('Tipo de método inválido. Debe ser "sms" o "email"');
    }

    return await this.authRepository.send2FACode(request, token);
  }
}

